import { render, staticRenderFns } from "./am5DonutChart.vue?vue&type=template&id=155188de&scoped=true"
import script from "./am5DonutChart.vue?vue&type=script&lang=js"
export * from "./am5DonutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155188de",
  null
  
)

export default component.exports